// Global guard for products that require fragrance selection before purchase.
// Product cards are marked server-side from these tags:
// fragrance-pack-4-of-6, Diffuser_Refill_Pack, bundle_30ml, bundle_100ml.
//
// Any quick-add/add-to-cart interaction from a marked product card redirects
// to the product page, where manish-fragrance-pack.js enforces the selection.
// The actual product-page purchase form is not marked, so normal purchasing
// continues there after the required fragrances are selected.
(function () {
  if (window.__scentitudeFragranceSelectionGuardInitialized) return;
  window.__scentitudeFragranceSelectionGuardInitialized = true;

  function getRestrictedContainer(element) {
    if (!element || !element.closest) return null;
    return element.closest('[data-fragrance-selection-required="true"]');
  }

  function getProductUrl(container, trigger) {
    if (!container) return "";

    var url =
      container.getAttribute("data-fragrance-product-url") ||
      (trigger && trigger.getAttribute && trigger.getAttribute("data-product-url")) ||
      "";

    if (!url) {
      var link = container.querySelector('a[href*="/products/"]');
      if (link) url = link.getAttribute("href") || "";
    }

    return url;
  }

  function redirectToProduct(event, container, trigger) {
    var url = getProductUrl(container, trigger);
    if (!url) return false;

    event.preventDefault();
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === "function") {
      event.stopImmediatePropagation();
    }

    window.location.assign(url);
    return true;
  }

  // Handles icon quick-add buttons, custom fragrance-carousel buttons,
  // modal quick-shop openers, and other add buttons rendered inside a
  // fragrance-selection-required product card.
  document.addEventListener(
    "click",
    function (event) {
      var trigger = event.target.closest(
        '.quick-add__submit, .fragrance-add-to-cart, modal-opener button[data-product-url], button[name="add"]'
      );
      if (!trigger) return;

      var container = getRestrictedContainer(trigger);
      if (!container) return;

      redirectToProduct(event, container, trigger);
    },
    true
  );

  // Keyboard/form-submit fallback for single-variant cards.
  document.addEventListener(
    "submit",
    function (event) {
      var form = event.target;
      if (
        !form ||
        !form.matches ||
        !form.matches('form[data-type="add-to-cart-form"], form[action*="/cart/add"]')
      ) {
        return;
      }

      var container = getRestrictedContainer(form);
      if (!container) return;

      redirectToProduct(event, container, form);
    },
    true
  );
})();
